<template>
  <div id="us-home" style="padding-top:100px;">
    授权成功, 正在加载...
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  },
  watch: {

  },
  mounted() {
  },
  created() {
    var that = this

    var code = that.$route.query.code
    var state = that.$route.query.state

    console.log('code', code)

    console.log('state', state)

    console.log('code2', code[1])

    console.log('state2', state[1])

    // if (state[1] === '/dev/home/share_qr_code') {
    //   code = code[1]
    //   state = state[1]
    // }

    if (code.length === 2) {
      code = code[1]
    }

    if (state.length === 2) {
      state = state[1]
    }

    that.$api.gzh.getWxUserInfo({ a_code: code }).then(res => {
      // console.log('getWxUserInfo.res:', JSON.stringify(res))
      if (!res.success) {
        console.log('授权失败', res);
        return
      }
      var data = res.data
      // store.commit('SET_USER', { acode: code, openid: data.openid, nick_name: data.nickname, head_url: data.headimgurl })
      that.$AppHelper.setUserInfo(data.user_info)
      that.$AppHelper.setUserTokenInfo(data.token_info);
      that.$AppHelper.authed = true
      // console.log('query', that.$route.query)
      // console.log('path', state)
      that.$router.push({ path: state, query: that.$route.query })
    })
  }
}

</script>

<style scoped>
#us-home {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 30px;
  padding-top: 30px;
}
</style>
